import { render, staticRenderFns } from "./dialogGoodslist.vue?vue&type=template&id=c487c74e"
import script from "./dialogGoodslist.vue?vue&type=script&lang=js"
export * from "./dialogGoodslist.vue?vue&type=script&lang=js"
import style0 from "./dialogGoodslist.vue?vue&type=style&index=0&id=c487c74e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports